import { Box, styled } from '@mui/material';

export const SubHeader = styled(Box)(({ theme }) => ({
    color: theme.palette.background.paper,
    backgroundColor: theme.palette.primary.main,
    height: '48px',
    width: '100%',
    alignItems: 'center',
    display: 'flex',
    paddingLeft: theme.spacing(2),
  }));
  